import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment.prod';

export interface DashboardSummary {
  total_leads: number;
  total_orders: number;
  total_deliveries: number;
  leads_by_status: { [status: string]: number };
  orders_by_status: { [status: string]: number };
  deliveries_by_status: { [status: string]: number };
}

export const DEFAULT_DASHBOARD_SUMMARY: DashboardSummary = {
  total_leads: 0,
  total_orders: 0,
  total_deliveries: 0,
  leads_by_status: { upcoming: 0 },
  orders_by_status: { pending: 0 },
  deliveries_by_status: { upcoming: 0 }
};


@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  //private baseUrl = 'http://localhost:8001/dashboard';
  private baseUrl = `${environment.apiBaseUrl}/api/dashboard`;


  private summarySource = new BehaviorSubject<any>(null);  
  summary$ = this.summarySource.asObservable(); // Other components can subscribe

  // Event trigger for other services/components to notify changes
  private refreshTrigger = new Subject<void>();

  constructor(private http: HttpClient, private auth: AuthService) {
    // When refresh is triggered, fetch summary again
    this.refreshTrigger.subscribe(() => this.fetchAndUpdateSummary());
  }

  getSummary(): Observable<DashboardSummary> {
    return this.http.get<DashboardSummary>(`${this.baseUrl}/summary`, this.auth.getAuthHeaders());
  }

  updateSummary(data: any) {
    this.summarySource.next(data); // Emit to all subscribers
  }

  fetchAndUpdateSummary() {
    this.getSummary().subscribe(data => {
      this.summarySource.next(data);
    });
  }

  triggerRefresh() {
    this.refreshTrigger.next();
  }
}
